// extracted by mini-css-extract-plugin
module.exports = {"fold-class":"fold-class-ba3ff1248795c6d18e59cafe168af888"};